import { IFormErrors } from '@interfaces/IFormsErrors';
import { IUser } from '@interfaces/IUser';

export interface IProfileViewState {
  data: IUser | null;
  isLoading: boolean;
  errors: IFormErrors | null;
}

export const initialsProfileViewState: IProfileViewState = {
  data: null,
  isLoading: false,
  errors: null,
};
